module.exports = __webpack_public_path__ + "static/media/swiper_button_left.900c9f69.svg";